import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SELECT_V2 } from '@app/formly/helpers/fields';
import { ContactMethodTypeInput } from '@app/generated/graphql';
import { RadarFormAbstract } from '@app/shared/components/radar-form-abstract';
import { mapEnumToDropdownItems } from '@app/shared/utils/dropdown-utils';
import { of } from 'rxjs';

@Component({
  selector: 'assign-lead-form',
  templateUrl: './assign-lead-form.component.html',
  styleUrls: ['./assign-lead-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignLeadFormComponent extends RadarFormAbstract implements OnInit {
  @Output() hideModal = new EventEmitter();

  ngOnInit(): void {
    super.ngOnInit();

    this.fields = [
      SELECT_V2(
        {
          key: 'contactedBy',
          props: {
            label: 'Contacted by',
            placeholder: 'Select',
            required: true,
          },
        },
        of(mapEnumToDropdownItems(ContactMethodTypeInput, { withoutColors: true })),
      ),
    ];
  }
}
